/* jshint esversion: 6 */
/* jshint esversion: 11 */
import React, { useContext, useEffect, useRef, useState } from "react";
import { MyContext } from "../../Context/MyProvider";
import axios from "axios";
import { TbMapPinFilled } from "react-icons/tb";
import Slider from "react-slick";
import {
  IoCheckmarkCircle,
  IoChevronBackOutline,
  IoCloseSharp,
} from "react-icons/io5";
import { showToast } from "../../showTost";
import { MdOutlineArrowCircleRight } from "react-icons/md";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import Chat from "./Chat";
import { useLocation, useNavigate } from "react-router-dom";
import test_tube from "../../assets/Icon/test_tube.svg";
import capsule from "../..//assets/Icon/capsule.svg";
import Hospital from "../../assets/Icon/hospital.svg";
import { useTranslation } from "react-i18next";
import Loading from "../Loading";
import secureLocalStorage from "react-secure-storage";
import ImageLoad from "../ImageLoad";
import MapPin from "../../assets/Icon/mappin.svg";
import {
  LuCalendar,
  LuMessageSquare,
  LuPhoneCall,
  LuMapPin,
  LuChevronRight,
  LuVideo,
  LuClock,
  LuInfo,
  LuDownload,
  LuStar,
} from "react-icons/lu";
const BookingDetails = () => {
  const { t } = useTranslation();

  const { ApiBaseUrl, ImgBaseUrl, mapKey } = useContext(MyContext);

  const Location = useLocation();
  const navigate = useNavigate();
  const Data = Location.state;

  const [doctorData, setDoctorData] = useState();
  const [sebserviceData, setSebserviceData] = useState();
  const [appointData, setAppointData] = useState();
  const [time, setTime] = useState({ hours: "", minutes: "", seconds: "" });
  const [familyData, setFamilyData] = useState([]);
  const [isPatientBox, setIsPatientBox] = useState();
  const [addDocument, setAddDocument] = useState([]);
  const [getDocument, setGetDocument] = useState([]);
  const [healthConcern, setHealthConcern] = useState();
  const [hospitalData, setHospitalData] = useState();
  const [isShowDownload, setIsShowDownload] = useState(true);
  const [selectPatient, setSelectPatient] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [vitalaInfoData, setVitalaInfoData] = useState([]);
  const [deviceCheck, setDeviceCheck] = useState(false);
  const [drugsInfoData, setDrugsInfoData] = useState([]);
  const [diagnosisData, setDiagnosisData] = useState([]);
  const [medicineDetails, setMedicineDetails] = useState();
  const [cancelReasonList, setCancelReasonList] = useState([]);
  const [isCancelBox, setIsCancelBox] = useState(false);
  const [selectReason, setSelectReason] = useState();
  const [otherReason, setOtherReason] = useState();
  const [loading, setLoading] = useState(true);
  const [showChat, setShowChat] = useState(false);
  const [selectDoc, setSelectDoc] = useState("");
  const [isReview, setIsReview] = useState(false);
  const [reviewIndex, setReviewIndex] = useState(1);
  const [reviewText, setReviewText] = useState();
  const [checkList, setCheckList] = useState();
  const [prescriptionload, setPrescriptionLod] = useState("");
  const [notificationlod, setNotificationLod] = useState(false);
  const [token, setToken] = useState("");

  const InputRef = useRef();
  const InputRef2 = useRef();

  const Userid = secureLocalStorage.getItem("Userid");

  const settings = {
    arrows: false,
    dots: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      { breakpoint: 1205, settings: { slidesToShow: 5, slidesToScroll: 1 } },
      { breakpoint: 770, settings: { slidesToShow: 6, slidesToScroll: 1 } },
      { breakpoint: 580, settings: { slidesToShow: 5, slidesToScroll: 1 } },
      { breakpoint: 430, settings: { slidesToShow: 4, slidesToScroll: 1 } },
      { breakpoint: 330, settings: { slidesToShow: 3, slidesToScroll: 1 } },
    ],
  };

  const settings2 = {
    arrows: false,
    dots: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      { breakpoint: 770, settings: { slidesToShow: 6, slidesToScroll: 1 } },
      { breakpoint: 430, settings: { slidesToShow: 4, slidesToScroll: 1 } },
    ],
  };

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: mapKey,
  });

  useEffect(() => {
    HandleFatchData();
  }, []);

  const HandleFatchData = () => {
    const AppointmentId = sessionStorage.getItem("Appintmentid");
    if (AppointmentId && Userid) {
      axios
        .post(`${ApiBaseUrl}/customer/appointment_detail`, {
          id: Userid,
          appointment_id: AppointmentId,
        })
        .then((res) => {
          console.log("appointment_detail", res);
          const {
            doctor,
            sebservice,
            appoint,
            family_member,
            hospital,
            ResponseCode,
            token_position,
          } = res.data;
          if (ResponseCode === 200) {
            setLoading(false);
            setDoctorData(doctor);
            setSebserviceData(sebservice);
            setAppointData(appoint);
            convertTime(appoint.timecount);
            setFamilyData(family_member);
            setSelectPatient(family_member[0]?.id);
            setHospitalData(hospital);
            setToken(token_position);
            const { vitals_physical, drugs_prescription, diagnosis_test } =
              appoint;
            setCheckList({
              vitals_physical,
              drugs_prescription,
              diagnosis_test,
            });
            if (
              vitals_physical !== 0 ||
              drugs_prescription !== 0 ||
              diagnosis_test !== 0
            ) {
              setIsShowDownload(false);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });

      axios
        .get(`${ApiBaseUrl}/customer/appint_cancel_list`)
        .then((res) => {
          // console.log("appint_cancel_list", res);
          setCancelReasonList(res.data.cancel_reason);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const convertTime = (time) => {
    const totalSeconds = parseInt(time, 10);

    let hours = Math.floor(totalSeconds / 3600);
    const remainingSecondsAfterHours = totalSeconds % 3600;
    let minutes = Math.floor(remainingSecondsAfterHours / 60);
    let seconds = remainingSecondsAfterHours % 60;

    setTime({ hours, minutes, seconds });
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setTime((prevTime) => {
        let { hours, minutes, seconds } = prevTime;

        if (hours === 0 && minutes === 0 && seconds === 0) {
          clearInterval(timer);
          return prevTime;
        }

        if (seconds === 0) {
          if (minutes === 0) {
            if (hours === 0) {
              return { hours: 0, minutes: 0, seconds: 0 };
            }
            return { hours: hours - 1, minutes: 59, seconds: 59 };
          }
          return { hours, minutes: minutes - 1, seconds: 59 };
        }

        return { hours, minutes, seconds: seconds - 1 };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [time]);

  const format = (unit) => String(unit).padStart(2, "0");

  const HandleRemovePhoto = (index, id) => {
    if (id === 1) {
      const Copy = [...addDocument];
      Copy.splice(index, 1);
      setAddDocument(Copy);
    } else {
      const AppointmentId = sessionStorage.getItem("Appintmentid");
      if (!Userid && !AppointmentId) return;

      const Data = {
        id: Userid,
        appointment_id: AppointmentId,
        fam_mem_id: String(isPatientBox.id),
        removed_image: getDocument[index]?.img,
      };

      axios
        .post(`${ApiBaseUrl}/customer/remove_pati_heal_image`, Data)
        .then((res) => {
          // console.log("remove_pati_heal_image", res);
          const { ResponseCode, message } = res.data;
          if (ResponseCode === 200) {
            const Copy = [...getDocument];
            Copy.splice(index, 1);
            setGetDocument(Copy);
            showToast({ title: message, id: "success" });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const handleFileSelect = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      const fileSizeInBytes = file.size;
      const fileSizeInMB = (fileSizeInBytes / (1024 * 1024)).toFixed(0);
      if (fileSizeInMB > "20") {
        showToast({ title: `${file.name} larger than 20MB`, id: "error" });
      } else {
        setAddDocument((prev) => [...prev, { type: "doc", img: file }]);
      }
    }
    e.target.value = null;
  };

  const HandleSubmitDetails = () => {
    const AppointmentId = sessionStorage.getItem("Appintmentid");

    if (Userid && AppointmentId) {
      const formData = new FormData();

      formData.append("id", Userid);
      formData.append("appointment_id", AppointmentId);
      formData.append("fam_mem_id", isPatientBox?.id);
      formData.append("health_concern", healthConcern);

      addDocument.forEach((item) => {
        formData.append("document", item.img);
      });

      axios
        .post(`${ApiBaseUrl}/customer/add_patient_health_concerns`, formData)
        .then((res) => {
          // console.log("add_patient_health_concerns", res);
          if (res.data.ResponseCode === 200) {
            showToast({ title: res.data.message, id: "success" });
            setIsPatientBox("");
            setAddDocument([]);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const HandleHealthConcerns = (item) => {
    const AppointmentId = sessionStorage.getItem("Appintmentid");

    if (Userid && AppointmentId) {
      axios
        .post(`${ApiBaseUrl}/customer/patient_health_concerns`, {
          id: Userid,
          appointment_id: AppointmentId,
          fam_mem_id: String(item.id),
        })
        .then((res) => {
          // console.log("patient_health_concerns", res);
          const { ResponseCode, document, health_concern } = res.data;
          if (ResponseCode === 200) {
            setHealthConcern(health_concern);
            const imageExtensions = [
              "png",
              "jpg",
              "jpeg",
              "gif",
              "bmp",
              "webp",
            ];
            const Doc = [];
            document.find((item) => {
              const extension = item.split(".")[1];
              if (imageExtensions.includes(extension)) {
                Doc.push({ type: "img", img: item });
              } else {
                Doc.push({ type: "doc", img: item });
              }
            });
            setGetDocument(Doc);
            setIsPatientBox(item);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const HandleNavigateMap = (laat, long) => {
    const lat = Number(laat);
    const lng = Number(long);
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
    window.open(googleMapsUrl, "_blank");
  };

  const HandleShowPdf = () => {
    if (isShowDownload) {
      showToast({
        title: t(
          "Doctor hasn't uploaded your details. Please contact them to update your info.",
        ),
        id: "warning",
      });
      return;
    }

    const AppointmentId = sessionStorage.getItem("Appintmentid");
    setIsLoading(true);
    if (selectPatient && Userid) {
      axios
        .post(`${ApiBaseUrl}/customer/generate_patient_pdf`, {
          id: Userid,
          appointment_id: AppointmentId,
          family_mem_id: String(selectPatient),
        })
        .then((res) => {
          // console.log(res);
          if (res.data.ResponseCode === 200) {
            setIsLoading(false);
            const Pdflink = ImgBaseUrl + res.data.pdf_URL;
            window.open(Pdflink, "_blank");
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const HandleNotification = () => {
    showToast({
      title: "For the demo version, the video call feature is disabled.",
      id: "info",
    });

    // if (Userid) {
    //     setNotificationLod(true);
    //     axios.post(`${ApiBaseUrl}/customer/send_doctor_notified`, { id: Userid, doctor_id: doctorData?.id })
    //         .then((res) => {
    //             // console.log(res);
    //             if (res.data.ResponseCode === 200) {
    //                 showToast({ title: res.data.message, id: "success" });
    //             }
    //             setNotificationLod(false);
    //         })
    //         .catch((error) => {
    //             console.error(error);
    //         });
    // }
  };

  const HandleVitalaInfo = (Api, parameter, setState, index, id) => {
    const AppointmentId = sessionStorage.getItem("Appintmentid");

    if (!prescriptionload && selectPatient && Userid) {
      setPrescriptionLod(id);

      axios
        .post(ApiBaseUrl + Api, {
          id: Userid,
          appointment_id: AppointmentId,
          patient_id: String(selectPatient),
        })
        .then((res) => {
          // console.log(res.data);
          setState(res.data[parameter]);
          const data = res.data[parameter];
          if (data.length <= 0) {
            showToast({ title: index, id: "error" });
          }
          setPrescriptionLod("");
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const HandleCancelAppointment = () => {
    if (!selectReason) {
      showToast({ title: t("Select Cancel Reason"), id: "error" });
      return;
    }

    if (selectReason === 4 && !otherReason) {
      showToast({ title: t("Enter Other Reason"), id: "error" });
      return;
    }

    const AppointmentId = sessionStorage.getItem("Appintmentid");
    if (Userid) {
      const Data = {
        id: Userid,
        appointment_id: AppointmentId,
        reason_id: selectReason,
        reason: otherReason ? otherReason : "",
      };

      axios
        .post(`${ApiBaseUrl}/customer/cancel_appointment`, Data)
        .then((res) => {
          if (res.data.ResponseCode === 200) {
            showToast({ title: res.data.message, id: "success" });
            setIsCancelBox(false);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const HandleChat = (Docid) => {
    setShowChat(true);
    setSelectDoc(Docid);
  };

  const AudioCallHandler = async (code, phone) => {
    try {
      const deviceList = await navigator.mediaDevices.enumerateDevices();
      let hasMicrophone = false;

      deviceList.forEach((device) => {
        if (device.kind === "audioinput") {
          hasMicrophone = true;
        }
      });

      if (!hasMicrophone) {
        setDeviceCheck(true);
        return;
      }
    } catch (error) {
      console.error("Error checking devices:", error);
    }
    window.location.href = `tel:${code + phone}`;
  };

  const HandleAddReview = () => {
    if (Userid) {
      axios
        .post(`${ApiBaseUrl}/customer/add_appint_review`, {
          id: Userid,
          appointment_id: appointData.id,
          review: reviewText || "",
          tot_star: reviewIndex,
        })
        .then((res) => {
          // console.log("/customer/add_appint_review", res);
          if (res.data.ResponseCode === 200) {
            setIsReview(false);
            showToast({ title: res.data.message, id: "success" });
            HandleFatchData();
          }
        })
        .catch((errro) => {
          console.error("/customer/add_appint_review", errro);
        });
    }
  };

  const HandleAppointCheckList = (id) => {
    setSelectPatient(id);
    setIsLoading(true);
    if (Userid) {
      axios
        .post(`${ApiBaseUrl}/customer/check_doc_appoint_upload`, {
          id: Userid,
          appointment_id: appointData?.id,
          fid: id,
        })
        .then((res) => {
          // console.log("check_doc_appoint_upload", res);
          setIsLoading(false);
          const { diagnosis_test, drugs_prescription, vitals_physical } =
            res.data;
          setCheckList({ vitals_physical, drugs_prescription, diagnosis_test });
          if (
            vitals_physical !== 0 ||
            drugs_prescription !== 0 ||
            diagnosis_test !== 0
          ) {
            setIsShowDownload(false);
          } else {
            setIsShowDownload(true);
          }
        })
        .catch((error) => {
          console.error("check_doc_appoint_upload", error);
        });
    }
  };
  return (
    <div className="booking-details-checkout-container w-full min-h-screen pb-[100px] content-wrapper px-4 md:px-6 max-w-7xl mx-auto">
      {loading ? (
        <Loading
          CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white z-[9999]"
          index={0}
        />
      ) : (
        <div className="flex flex-col">
          {/* Header Navigation / Breadcrumbs */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 py-4 mb-6 border-b border-slate-100">
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center gap-2 border border-slate-200 rounded-full px-4 py-2 hover:bg-slate-900 hover:text-white hover:border-slate-900 transition-all duration-200 shadow-sm"
            >
              <IoChevronBackOutline className="w-4 h-4" />
              <span className="font-medium text-sm">{t("Go Back")}</span>
            </button>

            <div className="flex items-center gap-2 text-sm text-slate-500">
              <span
                className="hover:text-indigo-650 font-medium transition-colors cursor-pointer"
                onClick={() => navigate("/dashbord")}
              >
                {t("Dashboard")}
              </span>
              <LuChevronRight className="w-3.5 h-3.5" />
              <span
                className="hover:text-indigo-650 font-medium transition-colors cursor-pointer"
                onClick={() => navigate("/booking")}
              >
                {t("My Bookings")}
              </span>
              <LuChevronRight className="w-3.5 h-3.5" />
              <span className="font-semibold text-slate-800">
                {t("Appointment Details")}
              </span>
            </div>
          </div>

          {/* Main Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-4">
            {/* Left Column (Main Booking & Doctor Info) - takes 2 cols on desktop */}
            <div className="lg:col-span-2 flex flex-col gap-6">
              {/* Doctor Hero Card */}
              <div className="bg-white rounded-3xl border border-slate-150 overflow-hidden shadow-sm flex flex-col">
                {/* Card Banner Cover */}
                <div className="relative h-56 bg-slate-100 overflow-hidden">
                  <ImageLoad
                    src={ImgBaseUrl + doctorData?.logo}
                    CustomeStyle="w-full h-full object-cover transition-transform duration-500 hover:scale-102"
                    alt={doctorData?.name}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-slate-900/20 to-transparent"></div>

                  {/* Status Badge */}
                  <div
                    className={`absolute top-4 right-4 px-3.5 py-1.5 rounded-full text-xs font-bold shadow-sm ${
                      appointData?.status === "5"
                        ? "bg-rose-50 text-rose-600 border border-rose-100"
                        : appointData?.status === "4"
                          ? "bg-emerald-50 text-emerald-700 border border-emerald-100"
                          : "bg-indigo-50 text-indigo-700 border border-indigo-100"
                    }`}
                  >
                    {appointData?.status === "0" && t("Pending")}
                    {appointData?.status === "1" && t("Accepted")}
                    {appointData?.status === "2" && t("Progress")}
                    {appointData?.status === "3" && t("Service Start")}
                    {appointData?.status === "4" && t("Completed")}
                    {appointData?.status === "5" && t("Canceled")}
                  </div>

                  {/* Floating call/chat buttons on doctor picture cover */}
                  <div className="absolute bottom-4 right-4 flex items-center gap-3">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        AudioCallHandler(
                          doctorData?.country_code,
                          doctorData?.phone,
                        );
                      }}
                      className="w-10 h-10 bg-white/95 backdrop-blur-md hover:bg-indigo-600 text-slate-700 hover:text-white rounded-full flex items-center justify-center shadow-md transition-all duration-200 active:scale-95"
                      title={t("Call Doctor")}
                    >
                      <LuPhoneCall className="w-4.5 h-4.5" />
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        HandleChat(doctorData?.id);
                      }}
                      className="w-10 h-10 bg-white/95 backdrop-blur-md hover:bg-indigo-600 text-slate-700 hover:text-white rounded-full flex items-center justify-center shadow-md transition-all duration-200 active:scale-95"
                      title={t("Message Doctor")}
                    >
                      <LuMessageSquare className="w-4.5 h-4.5" />
                    </button>
                  </div>

                  {/* Name & Department Overlay */}
                  <div className="absolute bottom-4 left-6">
                    <h1 className="text-white font-bold text-xl drop-shadow-sm">
                      {doctorData?.name}
                    </h1>
                    <p className="text-slate-200 text-sm font-medium mt-0.5">
                      {sebserviceData?.department_name}
                    </p>
                  </div>
                </div>
              </div>

              {/* About Appointment Card */}
              <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm flex flex-col gap-6">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <span className="text-slate-400 text-xs font-semibold uppercase tracking-wider block mb-1">
                      {t("Service Category")}
                    </span>
                    <h3 className="font-bold text-slate-800 text-lg leading-snug">
                      {sebserviceData?.sub_title}
                    </h3>
                  </div>
                  <div className="w-14 h-14 bg-indigo-50 rounded-2xl flex items-center justify-center border border-indigo-100 shrink-0">
                    <ImageLoad
                      src={ImgBaseUrl + sebserviceData?.image}
                      CustomeStyle="w-10 h-10 object-contain"
                      alt={sebserviceData?.sub_title}
                    />
                  </div>
                </div>

                {/* Date Time slot details */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="flex items-center gap-3.5 bg-slate-50 border border-slate-100 p-4 rounded-2xl">
                    <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center text-indigo-600 border border-slate-150 shadow-sm shrink-0">
                      <LuCalendar className="w-5 h-5" />
                    </div>
                    <div className="leading-tight">
                      <span className="text-slate-400 text-xs font-medium block">
                        {t("Appointment Date")}
                      </span>
                      <span className="text-slate-700 font-bold text-sm">
                        {appointData?.appointment_date}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center gap-3.5 bg-slate-50 border border-slate-100 p-4 rounded-2xl">
                    <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center text-indigo-600 border border-slate-150 shadow-sm shrink-0">
                      <LuClock className="w-5 h-5" />
                    </div>
                    <div className="leading-tight">
                      <span className="text-slate-400 text-xs font-medium block">
                        {t("Appointment Time")}
                      </span>
                      <span className="text-slate-700 font-bold text-sm">
                        {appointData?.appointment_time}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Visit Type & Hospital Container */}
                <div className="flex items-start gap-4 p-4 bg-slate-50 rounded-2xl border border-slate-100">
                  <div className="w-12 h-12 bg-white border border-slate-150 rounded-xl flex items-center justify-center shrink-0 shadow-sm">
                    {appointData?.show_type === "1" ? (
                      <img src={Hospital} className="w-7 h-7" alt="Hospital" />
                    ) : (
                      <LuVideo className="w-6 h-6 text-indigo-600" />
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="font-bold text-slate-800 text-[15px] truncate">
                      {hospitalData?.name}
                    </h4>
                    <p className="text-slate-500 text-xs font-medium mt-0.5">
                      {appointData?.show_type === "1"
                        ? t("In Person Appointment")
                        : t("In Video Appointment")}
                    </p>
                  </div>
                </div>

                {/* Video Call Action Banner (Only if pending & video consult) */}
                {Data?.status === 0 && appointData?.show_type === "2" && (
                  <div className="mt-2 border-t border-slate-100 pt-5">
                    {time.hours || time.minutes || time.seconds ? (
                      <div className="bg-indigo-50 border border-indigo-100 rounded-2xl p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                        <div className="flex items-center gap-3">
                          <span className="relative flex h-3 w-3">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-indigo-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-3 w-3 bg-indigo-600"></span>
                          </span>
                          <h5 className="font-bold text-indigo-900 text-sm">
                            {t("Consultation Starting Soon")}
                          </h5>
                        </div>
                        <div className="font-mono font-bold text-indigo-600 text-lg bg-white border border-indigo-150 px-3.5 py-1 rounded-xl shadow-sm">
                          {format(time.hours)}:{format(time.minutes)}:
                          {format(time.seconds)} {t("left")}
                        </div>
                      </div>
                    ) : (
                      Data?.status === 0 && (
                        <button
                          onClick={HandleNotification}
                          className="w-full py-3.5 bg-indigo-600 hover:bg-indigo-700 active:scale-99 text-white font-bold rounded-2xl transition-all duration-200 shadow-md shadow-indigo-600/10 flex items-center justify-center gap-2"
                        >
                          {notificationlod ? (
                            <div className="loader border-white mx-auto"></div>
                          ) : (
                            <>
                              <LuVideo className="w-5 h-5" />
                              <span>{t("Send Notification")}</span>
                            </>
                          )}
                        </button>
                      )
                    )}
                  </div>
                )}
              </div>

              {/* Patient info Upload details */}
              {Data?.status === 0 && (
                <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm">
                  <h3 className="font-bold text-slate-800 text-lg mb-1">
                    {t("Share Health Concerns")}
                  </h3>
                  <p className="text-slate-400 text-xs font-semibold uppercase tracking-wider mb-5">
                    {t(
                      "Select patient to upload health concerns prior to consultation",
                    )}
                  </p>

                  <div className="patient-slider-container">
                    <Slider {...settings}>
                      {familyData.map((item, index) => (
                        <div
                          onClick={() => HandleHealthConcerns(item)}
                          key={index}
                          className="p-2 focus:outline-none"
                        >
                          <div className="group flex flex-col items-center gap-3 cursor-pointer text-center">
                            <div className="w-16 h-16 rounded-full border-2 border-slate-200 group-hover:border-indigo-600 group-hover:scale-105 transition-all duration-300 overflow-hidden shadow-inner shrink-0 relative">
                              <ImageLoad
                                src={ImgBaseUrl + item.profile_image}
                                CustomeStyle="w-full h-full object-cover"
                                alt={item.name}
                              />
                            </div>
                            <div className="max-w-[70px] min-w-0">
                              <span className="font-bold text-slate-700 text-xs truncate block">
                                {item.name}
                              </span>
                            </div>
                            <span className="text-[10px] font-bold bg-indigo-50 border border-indigo-100 text-indigo-600 hover:bg-indigo-600 hover:text-white px-2.5 py-1 rounded-full transition-colors duration-200">
                              {t("Upload")}
                            </span>
                          </div>
                        </div>
                      ))}
                    </Slider>
                  </div>
                </div>
              )}

              {/* Token Queue Status */}
              {token && (
                <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm flex flex-col md:flex-row items-center gap-6 justify-between">
                  <div className="text-center md:text-left shrink-0">
                    <span className="text-slate-400 text-xs font-semibold uppercase tracking-wider block mb-1">
                      {t("Your Appointment Token")}
                    </span>
                    <div className="inline-block bg-indigo-50 text-indigo-600 border border-indigo-100 rounded-2xl px-6 py-3 font-mono font-black text-3xl shadow-sm">
                      #{token?.my_queue_token}
                    </div>
                    <div className="flex items-center justify-center md:justify-start gap-1.5 mt-2.5">
                      <span className="w-2.5 h-2.5 bg-emerald-500 rounded-full animate-pulse"></span>
                      <span className="text-xs font-bold text-slate-500">
                        {t("Active Queue Waiting")}
                      </span>
                    </div>
                  </div>

                  <div className="hidden md:block w-px h-16 bg-slate-200"></div>

                  <div className="flex-1 w-full grid grid-cols-2 gap-4">
                    <div className="bg-slate-50 border border-slate-100 rounded-2xl p-4 text-center">
                      <span className="text-slate-400 text-xs font-semibold block mb-1">
                        {t("Now Serving")}
                      </span>
                      <span className="font-black text-2xl text-slate-800">
                        #{token?.running_queue}
                      </span>
                    </div>
                    <div className="bg-slate-50 border border-slate-100 rounded-2xl p-4 text-center">
                      <span className="text-slate-400 text-xs font-semibold block mb-1">
                        {t("Ahead of You")}
                      </span>
                      <span className="font-black text-2xl text-slate-800">
                        {token?.patients_ahead}
                      </span>
                    </div>
                  </div>
                </div>
              )}

              {/* Map Address Panel */}
              <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm flex flex-col gap-4">
                <div className="flex items-center gap-2">
                  <LuMapPin className="w-5 h-5 text-indigo-655 shrink-0" />
                  <h3 className="font-bold text-slate-800 text-lg">
                    {t("Hospital Address")}
                  </h3>
                </div>

                <div className="w-full h-64 rounded-2xl overflow-hidden border border-slate-150 shadow-inner relative z-0">
                  {isLoaded && (
                    <GoogleMap
                      center={{
                        lat: Number(hospitalData?.latitude),
                        lng: Number(hospitalData?.longitude),
                      }}
                      zoom={17}
                      mapContainerStyle={{ width: "100%", height: "100%" }}
                      options={{
                        draggable: false,
                        scrollwheel: false,
                        disableDoubleClickZoom: true,
                        keyboardShortcuts: false,
                        zoomControl: false,
                        mapTypeControl: false,
                        streetViewControl: false,
                        fullscreenControl: false,
                      }}
                    >
                      <Marker
                        icon={{
                          url: MapPin,
                          scaledSize: new window.google.maps.Size(25, 25),
                        }}
                        position={{
                          lat: Number(hospitalData?.latitude),
                          lng: Number(hospitalData?.longitude),
                        }}
                      />
                    </GoogleMap>
                  )}
                </div>

                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mt-2">
                  <div className="flex-1 min-w-0">
                    <h4 className="font-bold text-slate-700 text-sm truncate">
                      {hospitalData?.name}
                    </h4>
                    <p className="text-slate-500 text-xs font-medium mt-0.5 line-clamp-1">
                      {hospitalData?.address}
                    </p>
                  </div>
                  <button
                    onClick={() =>
                      HandleNavigateMap(
                        hospitalData?.latitude,
                        hospitalData?.longitude,
                      )
                    }
                    className="w-full sm:w-auto inline-flex items-center justify-center gap-1.5 border border-slate-205 hover:border-indigo-500 rounded-full px-5 py-2.5 hover:bg-indigo-50 text-indigo-650 hover:text-indigo-700 font-bold text-sm transition-all duration-200 shrink-0"
                  >
                    <TbMapPinFilled className="w-4 h-4 text-indigo-600" />
                    <span>{t("Get Directions")}</span>
                  </button>
                </div>
              </div>
            </div>

            {/* Right Column (Checklists, Billing & Actions) - takes 1 col */}
            <div className="flex flex-col gap-6">
              {/* OTP info & QR code (if pending) */}
              {Data?.status === 0 && (
                <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm flex flex-col items-center text-center gap-4">
                  <div className="w-full">
                    <h3 className="font-bold text-slate-800 text-lg mb-1">
                      {t("OTP Verification")}
                    </h3>
                    <p className="text-slate-400 text-xs font-semibold uppercase tracking-wider">
                      {appointData?.status === "1"
                        ? t("Start OTP")
                        : t("End OTP")}
                    </p>
                  </div>

                  <div className="bg-indigo-50 border border-indigo-100 rounded-2xl px-6 py-3 font-mono font-black text-2xl text-indigo-600 tracking-widest shadow-sm">
                    {appointData?.otp}
                  </div>

                  <div className="w-full border-t border-slate-100 pt-4 flex flex-col items-center gap-2">
                    <h4 className="font-bold text-slate-700 text-sm">
                      {t("Check-In QR Code")}
                    </h4>
                    <div className="bg-slate-50 border border-slate-100 p-2.5 rounded-2xl shadow-inner">
                      <img
                        src={appointData?.qrcode}
                        className="w-36 h-36 object-contain"
                        alt="Checkin QR"
                      />
                    </div>
                  </div>
                </div>
              )}

              {/* Booking Checklists */}
              <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm flex flex-col gap-5">
                <div>
                  <h3 className="font-bold text-slate-800 text-lg mb-1">
                    {t("Appointment Checklist")}
                  </h3>
                  <p className="text-slate-400 text-xs font-semibold uppercase tracking-wider">
                    {t("Check patient results & prescriptions")}
                  </p>
                </div>

                {/* Patient Checklist Selectors */}
                <div className="patient-checklist-list mt-1">
                  <Slider {...settings}>
                    {familyData.map((item, index) => (
                      <div
                        key={index}
                        onClick={() => HandleAppointCheckList(item.id)}
                        className="p-2 focus:outline-none"
                      >
                        <div className="flex flex-col items-center gap-2 cursor-pointer text-center">
                          <div
                            className={`w-12 h-12 rounded-full overflow-hidden border-2 transition-all duration-300 relative ${
                              selectPatient === item.id
                                ? "border-indigo-600 ring-2 ring-indigo-600 ring-offset-2 scale-102"
                                : "border-slate-200 hover:border-slate-400"
                            }`}
                          >
                            <ImageLoad
                              src={ImgBaseUrl + item.profile_image}
                              CustomeStyle="w-full h-full object-cover"
                              alt={item.name}
                            />
                          </div>
                          <span
                            className={`font-bold text-[10px] truncate max-w-[60px] block ${
                              selectPatient === item.id
                                ? "text-indigo-650"
                                : "text-slate-400"
                            }`}
                          >
                            {item.name}
                          </span>
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>

                {/* Checklist Action buttons */}
                <div className="flex flex-col gap-3.5 mt-2">
                  <button
                    onClick={() =>
                      HandleVitalaInfo(
                        "/customer/appoi_vit_phy_list",
                        "vit_phy_list",
                        setVitalaInfoData,
                        "No Vitala & Physical placed !!",
                        1,
                      )
                    }
                    disabled={checkList?.vitals_physical === 0}
                    className={`w-full flex items-center justify-between p-3.5 rounded-2xl border text-left transition-all duration-200 ${
                      checkList?.vitals_physical === 0
                        ? "bg-slate-50 border-slate-100 cursor-not-allowed opacity-60"
                        : "bg-white hover:bg-slate-50 border-slate-200 hover:border-slate-300 active:scale-99 shadow-sm"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <IoCheckmarkCircle
                        className={`w-6 h-6 shrink-0 ${
                          checkList?.vitals_physical === 0
                            ? "text-slate-300"
                            : "text-emerald-500"
                        }`}
                      />
                      <div className="leading-tight">
                        <h5 className="font-bold text-slate-800 text-sm">
                          {t("Vitals & Physical info")}
                        </h5>
                        <span className="text-[11px] text-slate-400 font-medium">
                          {t("Physical examination stats")}
                        </span>
                      </div>
                    </div>
                    {prescriptionload === 1 ? (
                      <div className="loader border-indigo-600 shrink-0"></div>
                    ) : (
                      <MdOutlineArrowCircleRight className="w-5 h-5 text-slate-400 shrink-0" />
                    )}
                  </button>

                  <button
                    onClick={() =>
                      HandleVitalaInfo(
                        "/customer/appo_dru_pres_list",
                        "drug_presciption",
                        setDrugsInfoData,
                        "No Drugs & Precription placed !!",
                        2,
                      )
                    }
                    disabled={checkList?.drugs_prescription === 0}
                    className={`w-full flex items-center justify-between p-3.5 rounded-2xl border text-left transition-all duration-200 ${
                      checkList?.drugs_prescription === 0
                        ? "bg-slate-50 border-slate-100 cursor-not-allowed opacity-60"
                        : "bg-white hover:bg-slate-50 border-slate-200 hover:border-slate-300 active:scale-99 shadow-sm"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <IoCheckmarkCircle
                        className={`w-6 h-6 shrink-0 ${
                          checkList?.drugs_prescription === 0
                            ? "text-slate-300"
                            : "text-emerald-500"
                        }`}
                      />
                      <div className="leading-tight">
                        <h5 className="font-bold text-slate-800 text-sm">
                          {t("Drugs & Prescription info")}
                        </h5>
                        <span className="text-[11px] text-slate-400 font-medium">
                          {t("Medication instructions")}
                        </span>
                      </div>
                    </div>
                    {prescriptionload === 2 ? (
                      <div className="loader border-indigo-600 shrink-0"></div>
                    ) : (
                      <MdOutlineArrowCircleRight className="w-5 h-5 text-slate-400 shrink-0" />
                    )}
                  </button>

                  <button
                    onClick={() =>
                      HandleVitalaInfo(
                        "/customer/appo_diagnosis_list",
                        "appoint",
                        setDiagnosisData,
                        "No Diagnosis placed !!",
                        3,
                      )
                    }
                    disabled={checkList?.diagnosis_test === 0}
                    className={`w-full flex items-center justify-between p-3.5 rounded-2xl border text-left transition-all duration-200 ${
                      checkList?.diagnosis_test === 0
                        ? "bg-slate-50 border-slate-100 cursor-not-allowed opacity-60"
                        : "bg-white hover:bg-slate-50 border-slate-200 hover:border-slate-300 active:scale-99 shadow-sm"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <IoCheckmarkCircle
                        className={`w-6 h-6 shrink-0 ${
                          checkList?.diagnosis_test === 0
                            ? "text-slate-300"
                            : "text-emerald-500"
                        }`}
                      />
                      <div className="leading-tight">
                        <h5 className="font-bold text-slate-800 text-sm">
                          {t("Diagnosis Tests")}
                        </h5>
                        <span className="text-[11px] text-slate-400 font-medium">
                          {t("Diagnostic lab checks")}
                        </span>
                      </div>
                    </div>
                    {prescriptionload === 3 ? (
                      <div className="loader border-indigo-600 shrink-0"></div>
                    ) : (
                      <MdOutlineArrowCircleRight className="w-5 h-5 text-slate-400 shrink-0" />
                    )}
                  </button>
                </div>

                {/* Download prescription button */}
                <button
                  onClick={HandleShowPdf}
                  className={`w-full py-3.5 font-bold text-sm text-white rounded-2xl transition-all duration-200 shadow-md ${
                    isLoading
                      ? "bg-indigo-400 cursor-wait"
                      : isShowDownload
                        ? "bg-slate-300 cursor-not-allowed shadow-none"
                        : "bg-indigo-600 hover:bg-indigo-700 active:scale-99 shadow-indigo-600/10"
                  }`}
                >
                  {isLoading ? (
                    <div className="loader border-white mx-auto"></div>
                  ) : (
                    <span className="flex items-center justify-center gap-2">
                      <LuDownload className="w-4 h-4" />
                      <span>{t("Download Prescription")}</span>
                    </span>
                  )}
                </button>
              </div>

              {/* Cancellation message box (only if status is canceled) */}
              {appointData?.status === "5" && (
                <div className="bg-rose-50/50 border border-rose-100 rounded-3xl p-6 flex flex-col gap-2">
                  <h3 className="font-bold text-rose-800 text-lg">
                    {t("Appointment Cancelled")}
                  </h3>
                  <p className="text-slate-500 text-sm leading-relaxed">
                    <span className="font-semibold text-rose-700">
                      {t("Reason")}:
                    </span>{" "}
                    {appointData?.cancel_reason || appointData?.cancel_title}
                  </p>
                </div>
              )}

              {/* Billing details */}
              <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm flex flex-col gap-4">
                <div>
                  <h3 className="font-bold text-slate-800 text-lg mb-1">
                    {t("Bill Summary")}
                  </h3>
                  <p className="text-slate-400 text-xs font-semibold uppercase tracking-wider">
                    {t("Cost breakdown & transactions")}
                  </p>
                </div>

                <div className="flex flex-col gap-3 mt-2">
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-slate-505 font-medium">
                      {t("Consultation Fee")}
                    </span>
                    <span className="text-slate-700 font-bold">
                      ${appointData?.show_type_price}.0
                    </span>
                  </div>

                  {appointData?.additional_price !== 0 && (
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-slate-505 font-medium">
                        {t("Additional Charge")}
                      </span>
                      <span className="text-slate-700 font-bold">
                        ${appointData?.additional_price}
                      </span>
                    </div>
                  )}

                  <div className="flex items-center justify-between text-sm">
                    <div className="flex items-center gap-1.5 text-slate-500">
                      <span className="font-medium">
                        {t("Service Fee & Tax")}
                      </span>
                      <div className="tooltip shrink-0">
                        <LuInfo className="w-4 h-4 text-slate-400 hover:text-indigo-600 cursor-pointer" />
                        <div className="tooltiptext">
                          <p className="text-white text-[11px] font-semibold">
                            {t("Service Fee")}: ${appointData?.site_commisiion}
                          </p>
                          <p className="text-white text-[11px] font-semibold mt-1">
                            {t("Tax Commission")}: $
                            {appointData?.doctor_commission}
                          </p>
                        </div>
                      </div>
                    </div>
                    <span className="text-slate-700 font-bold">
                      $
                      {appointData?.site_commisiion +
                        appointData?.doctor_commission}
                    </span>
                  </div>

                  {appointData?.coupon_amount !== 0 && (
                    <div className="flex items-center justify-between text-sm text-emerald-600 font-semibold">
                      <span>{t("Coupon discount")}</span>
                      <span>-${appointData?.coupon_amount}.0</span>
                    </div>
                  )}

                  {appointData?.wallet_amount !== 0 && (
                    <div className="flex items-center justify-between text-sm text-emerald-600 font-semibold">
                      <span>{t("Wallet Payment")}</span>
                      <span>-${appointData?.wallet_amount}</span>
                    </div>
                  )}

                  {appointData?.payment_name !== "Cash" &&
                    appointData?.payment_name && (
                      <div className="flex items-center justify-between text-sm">
                        <span className="text-slate-500 font-medium">
                          {t("Online Paid")} ({appointData?.payment_name})
                        </span>
                        <span className="text-slate-700 font-bold">
                          ${appointData?.online_amount}
                        </span>
                      </div>
                    )}

                  <div className="border-t border-slate-100 border-dashed my-1.5"></div>

                  <div className="flex items-center justify-between">
                    <span className="font-black text-slate-800 text-[15px]">
                      {t("Total Price")}
                    </span>
                    <span className="font-black text-indigo-600 text-lg">
                      ${appointData?.tot_price}
                    </span>
                  </div>

                  {appointData?.transactionId && (
                    <div className="mt-2 text-[11px] font-semibold text-slate-400 leading-tight">
                      {t("Transaction ID")}:{" "}
                      <span className="text-slate-505 font-mono">
                        {appointData?.transactionId}
                      </span>
                    </div>
                  )}
                </div>
              </div>

              {/* Booking Date & Time Info */}
              <div className="bg-slate-50 border border-slate-150 p-4 rounded-2xl flex items-center justify-between text-xs font-semibold text-slate-505">
                <span>{t("Booking Created On")}</span>
                <span className="text-slate-700 font-bold">
                  {appointData?.book_date}
                </span>
              </div>

              {/* Bottom Actions (Cancel / Review Buttons) */}
              {appointData?.status !== "5" && (
                <div className="flex items-center gap-3">
                  {appointData?.status !== "4" ? (
                    <button
                      onClick={() => setIsCancelBox(true)}
                      className="w-full py-3.5 bg-rose-50 hover:bg-rose-100 border border-rose-200/55 hover:border-rose-305 text-rose-600 font-bold text-sm rounded-2xl transition-all duration-200 active:scale-98"
                    >
                      {t("Cancel Appointment")}
                    </button>
                  ) : (
                    <button
                      onClick={() => setIsReview(true)}
                      className="w-full py-3.5 bg-indigo-600 hover:bg-indigo-700 text-white font-bold text-sm rounded-2xl transition-all duration-200 active:scale-98 shadow-md shadow-indigo-600/10 flex items-center justify-center gap-2"
                    >
                      <LuStar className="w-4 h-4 fill-white text-white" />
                      <span>{t("Leave a Review")}</span>
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modals & Overlays section (centered, glassmorphic blur) */}
      {isPatientBox && (
        <div
          onClick={() => setIsPatientBox("")}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-3xl p-6 shadow-2xl max-w-lg w-full max-h-[85vh] overflow-y-auto relative flex flex-col gap-5"
          >
            <button
              onClick={() => setIsPatientBox("")}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-650 hover:bg-slate-100 transition-all duration-200"
            >
              <IoCloseSharp className="w-6 h-6" />
            </button>

            <div>
              <h2 className="font-bold text-slate-800 text-lg leading-snug">
                {t("Share Health Concerns")}
              </h2>
              <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mt-0.5">
                {t("Prior to your consultation with")}{" "}
                <span className="text-indigo-600">{doctorData?.name}</span>
              </p>
            </div>

            <div className="flex items-center gap-4 p-3 bg-slate-50 rounded-2xl border border-slate-100">
              <div className="w-14 h-14 rounded-xl border border-slate-150 overflow-hidden shrink-0">
                <ImageLoad
                  src={ImgBaseUrl + isPatientBox?.profile_image}
                  CustomeStyle="w-full h-full object-cover"
                  alt={isPatientBox?.name}
                />
              </div>
              <div>
                <h4 className="font-bold text-slate-800 text-[15px]">
                  {isPatientBox?.name}
                </h4>
                <p className="text-slate-500 text-xs font-medium mt-0.5">
                  {isPatientBox?.gender}, {isPatientBox?.patient_age} Yrs
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-1.5">
              <label className="font-bold text-slate-700 text-sm">
                {t("Health Concerns")}
              </label>
              <input
                value={healthConcern}
                onChange={(e) => setHealthConcern(e.target.value)}
                type="text"
                className="border border-slate-200 w-full rounded-2xl py-3 px-4 focus-within:outline-none focus:border-indigo-650 focus:ring-1 focus:ring-indigo-650 text-sm shadow-sm"
                placeholder={t("Enter Disease or concerns")}
              />
            </div>

            <div className="flex flex-col gap-2">
              <label className="font-bold text-slate-700 text-sm">
                {t("Add Health Documents")}
              </label>
              <p className="text-slate-500 text-[11px] leading-relaxed">
                {t("E.g. Past Prescription, Test Report, Photo, etc.")}
                <br />
                {t("Maximum File Upload Size")}:{" "}
                <span className="text-slate-800 font-bold">20 MB</span> /{" "}
                {t("Document")}
              </p>

              <div className="grid grid-cols-2 gap-3 mt-1">
                <button
                  onClick={() => InputRef.current.click()}
                  className="py-2.5 px-4 bg-slate-50 hover:bg-slate-100 border border-slate-200 rounded-xl text-slate-700 font-bold text-xs transition-all duration-150 active:scale-98 flex items-center justify-center gap-1.5 shadow-sm"
                >
                  <span>{t("Add Photo")}</span>
                </button>
                <button
                  onClick={() => InputRef2.current.click()}
                  className="py-2.5 px-4 bg-slate-50 hover:bg-slate-100 border border-slate-200 rounded-xl text-slate-700 font-bold text-xs transition-all duration-150 active:scale-98 flex items-center justify-center gap-1.5 shadow-sm"
                >
                  <span>{t("Add Document")}</span>
                </button>

                <input
                  ref={InputRef}
                  onChange={(e) => {
                    if (e.target.files && e.target.files[0]) {
                      const file = e.target.files[0];
                      setAddDocument((prev) => [
                        ...prev,
                        { type: "img", img: file },
                      ]);
                    }
                    e.target.value = null;
                  }}
                  accept="image/*"
                  type="file"
                  className="hidden"
                />

                <input
                  ref={InputRef2}
                  className="hidden"
                  type="file"
                  name="light_image"
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,.ppt,.pptx"
                  onChange={handleFileSelect}
                />
              </div>
            </div>

            {/* Document Lists (Slider display) */}
            {(getDocument.length > 0 || addDocument.length > 0) && (
              <div className="mt-1 border-t border-slate-100 pt-4">
                <span className="font-bold text-slate-750 text-xs block mb-3">
                  {t("Uploaded Items")}
                </span>
                <div className="patient-doc-slider relative">
                  <Slider {...settings2}>
                    {getDocument.map((item, index) => {
                      const image =
                        item.type === "img"
                          ? ImgBaseUrl + item.img
                          : "./assets/Icon/Doc.svg";
                      return (
                        <div
                          key={index}
                          className="px-1.5 focus:outline-none relative"
                        >
                          <div className="relative h-28 border border-slate-150 rounded-2xl overflow-hidden shadow-inner bg-slate-50">
                            <ImageLoad
                              src={image}
                              CustomeStyle={`w-full h-full ${item.type === "img" ? "object-cover" : "object-contain p-4"}`}
                              alt={`Uploaded ${index}`}
                            />
                            <button
                              onClick={() => HandleRemovePhoto(index, 2)}
                              className="absolute top-1.5 right-1.5 bg-rose-600 hover:bg-rose-700 text-white rounded-full p-1.5 shadow-md transition-all active:scale-90"
                            >
                              <IoCloseSharp className="w-3.5 h-3.5" />
                            </button>
                          </div>
                        </div>
                      );
                    })}
                    {addDocument.map((item, index) => {
                      const image =
                        item.type === "img"
                          ? URL.createObjectURL(item.img)
                          : "./assets/Icon/Doc.svg";
                      return (
                        <div
                          key={index}
                          className="px-1.5 focus:outline-none relative"
                        >
                          <div className="relative h-28 border border-slate-150 rounded-2xl overflow-hidden shadow-inner bg-slate-50">
                            <ImageLoad
                              src={image}
                              CustomeStyle={`w-full h-full ${item.type === "img" ? "object-cover" : "object-contain p-4"}`}
                              alt={`Uploaded ${index}`}
                            />
                            <button
                              onClick={() => HandleRemovePhoto(index, 1)}
                              className="absolute top-1.5 right-1.5 bg-rose-600 hover:bg-rose-700 text-white rounded-full p-1.5 shadow-md transition-all active:scale-90"
                            >
                              <IoCloseSharp className="w-3.5 h-3.5" />
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                </div>
              </div>
            )}

            <button
              onClick={HandleSubmitDetails}
              className="w-full mt-2 py-3.5 bg-indigo-600 hover:bg-indigo-700 active:scale-99 text-white font-bold rounded-2xl transition-all duration-200 shadow-md shadow-indigo-600/10"
            >
              {t("Submit Details")}
            </button>
          </div>
        </div>
      )}

      {vitalaInfoData.length > 0 && (
        <div
          onClick={() => setVitalaInfoData("")}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-3xl p-6 shadow-2xl max-w-md w-full max-h-[80vh] overflow-y-auto relative flex flex-col gap-4"
          >
            <button
              onClick={() => setVitalaInfoData("")}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-650 hover:bg-slate-100 transition-all duration-200"
            >
              <IoCloseSharp className="w-6 h-6" />
            </button>

            <div>
              <h2 className="font-bold text-slate-800 text-lg leading-snug">
                {t("Vitals & Physical Stats")}
              </h2>
              <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mt-0.5">
                {t("Doctor physical evaluation notes")}
              </p>
            </div>

            <div className="flex flex-col gap-3 mt-2">
              {vitalaInfoData.map((item, index) => (
                <div
                  key={index}
                  className="p-3.5 bg-slate-50 border border-slate-100 rounded-2xl"
                >
                  <span className="text-slate-400 text-[11px] font-bold uppercase tracking-wider block mb-1">
                    {item.title}
                  </span>
                  <p className="text-slate-800 font-semibold text-sm leading-relaxed">
                    {item.text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {drugsInfoData.length > 0 && (
        <div
          onClick={() => setDrugsInfoData("")}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-3xl p-6 shadow-2xl max-w-lg w-full max-h-[80vh] overflow-y-auto relative flex flex-col gap-4"
          >
            <button
              onClick={() => setDrugsInfoData("")}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-650 hover:bg-slate-100 transition-all duration-200"
            >
              <IoCloseSharp className="w-6 h-6" />
            </button>

            <div>
              <h2 className="font-bold text-slate-800 text-lg leading-snug">
                {t("Prescribed Medications")}
              </h2>
              <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mt-0.5">
                {t("Dosage, duration & schedule guidelines")}
              </p>
            </div>

            <div className="flex flex-col gap-3.5 mt-2">
              {drugsInfoData.map((item, index) => (
                <div
                  key={index}
                  className="border border-slate-150 p-4 rounded-2xl bg-white shadow-sm hover:border-indigo-500/20 transition-all duration-150 flex flex-col justify-between"
                >
                  <div className="flex items-start justify-between gap-4">
                    <div>
                      <h4 className="font-bold text-slate-800 text-[15px]">
                        {item.medicine_name} {item.type}
                      </h4>
                    </div>
                    <div className="w-9 h-9 bg-indigo-50 border border-indigo-100 rounded-xl flex items-center justify-center shrink-0">
                      <img
                        src={capsule}
                        className="w-5 h-5 object-contain"
                        alt="capsule"
                      />
                    </div>
                  </div>
                  <span className="text-slate-405 text-xs font-semibold mt-1">
                    1 Spoon | {item.Dosage} | {item.Days}
                  </span>

                  <div className="mt-3.5 pt-3 border-t border-slate-100 flex flex-wrap items-center justify-between gap-3">
                    <div className="flex items-center gap-2">
                      <span className="text-xs bg-red-50 border border-rose-100 text-rose-650 font-bold px-2.5 py-1 rounded-lg">
                        {item.Time}
                      </span>
                      <span className="text-xs bg-slate-50 border border-slate-100 text-slate-600 font-bold px-2.5 py-1 rounded-lg">
                        {item.Frequency}
                      </span>
                    </div>

                    <button
                      onClick={() => setMedicineDetails(item)}
                      className="text-xs text-indigo-650 hover:text-indigo-700 font-bold inline-flex items-center gap-1"
                    >
                      <span>{t("View Details")}</span>
                      <LuChevronRight className="w-4 h-4" />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {medicineDetails && (
        <div
          onClick={() => setMedicineDetails("")}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[1000] p-4 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-3xl p-6 shadow-2xl max-w-md w-full max-h-[80vh] overflow-y-auto relative flex flex-col gap-5"
          >
            <button
              onClick={() => setMedicineDetails("")}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-655 hover:bg-slate-100 transition-all duration-200"
            >
              <IoCloseSharp className="w-6 h-6" />
            </button>

            <div>
              <h2 className="font-bold text-slate-800 text-lg leading-snug">
                {t("Medication Info")}
              </h2>
              <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mt-0.5">
                {t("Detailed drug prescription details")}
              </p>
            </div>

            <div className="flex flex-col gap-4 mt-2">
              <div className="p-3.5 bg-slate-50 border border-slate-100 rounded-2xl">
                <span className="text-slate-400 text-[10px] font-bold uppercase block mb-1">
                  {t("Medicine Name")}
                </span>
                <h4 className="font-bold text-slate-800 text-base">
                  {medicineDetails?.medicine_name} {medicineDetails?.Dosage}
                </h4>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div className="p-3.5 bg-slate-50 border border-slate-100 rounded-2xl">
                  <span className="text-slate-400 text-[10px] font-bold uppercase block mb-1">
                    {t("Dosage")}
                  </span>
                  <span className="font-bold text-slate-750 text-sm">
                    {medicineDetails?.Dosage}
                  </span>
                </div>
                <div className="p-3.5 bg-slate-50 border border-slate-100 rounded-2xl">
                  <span className="text-slate-400 text-[10px] font-bold uppercase block mb-1">
                    {t("Duration")}
                  </span>
                  <span className="font-bold text-slate-750 text-sm">
                    {medicineDetails?.Days}
                  </span>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div className="p-3.5 bg-slate-50 border border-slate-100 rounded-2xl">
                  <span className="text-slate-400 text-[10px] font-bold uppercase block mb-1">
                    {t("Time Schedule")}
                  </span>
                  <span className="font-bold text-slate-750 text-sm">
                    {medicineDetails?.Time}
                  </span>
                </div>
                <div className="p-3.5 bg-slate-50 border border-slate-100 rounded-2xl">
                  <span className="text-slate-400 text-[10px] font-bold uppercase block mb-1">
                    {t("Frequency")}
                  </span>
                  <span className="font-bold text-slate-750 text-sm">
                    {medicineDetails?.Frequency}
                  </span>
                </div>
              </div>

              {medicineDetails?.Instructions && (
                <div className="p-3.5 bg-slate-50 border border-slate-100 rounded-2xl">
                  <span className="text-slate-400 text-[10px] font-bold uppercase block mb-1">
                    {t("Instructions")}
                  </span>
                  <p className="text-slate-700 font-medium text-sm leading-relaxed">
                    {medicineDetails?.Instructions}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {diagnosisData.length > 0 && (
        <div
          onClick={() => setDiagnosisData("")}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-3xl p-6 shadow-2xl max-w-md w-full max-h-[80vh] overflow-y-auto relative flex flex-col gap-4"
          >
            <button
              onClick={() => setDiagnosisData("")}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-650 hover:bg-slate-100 transition-all duration-200"
            >
              <IoCloseSharp className="w-6 h-6" />
            </button>

            <div>
              <h2 className="font-bold text-slate-800 text-lg leading-snug">
                {t("Recommended Diagnosis Tests")}
              </h2>
              <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mt-0.5">
                {t("Prescribed diagnostic evaluations")}
              </p>
            </div>

            <div className="flex flex-col gap-3 mt-2">
              {diagnosisData.map((item, index) => (
                <div
                  key={index}
                  className="p-4 border border-slate-150 rounded-2xl bg-white shadow-sm flex items-start gap-4 hover:border-indigo-500/20 transition-all duration-150"
                >
                  <div className="w-10 h-10 bg-indigo-50 border border-indigo-100 rounded-xl flex items-center justify-center shrink-0">
                    <img
                      src={test_tube}
                      className="w-6 h-6 object-contain"
                      alt="test_tube"
                    />
                  </div>
                  <div className="leading-snug">
                    <h4 className="font-bold text-slate-800 text-[15px]">
                      {item.name}
                    </h4>
                    <p className="text-slate-505 text-xs font-medium mt-1 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {isCancelBox && (
        <div
          onClick={() => setIsCancelBox(false)}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-3xl p-6 shadow-2xl max-w-md w-full max-h-[80vh] scroll-container relative flex flex-col gap-5"
          >
            <button
              onClick={() => setIsCancelBox(false)}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-650 hover:bg-slate-100 transition-all duration-200"
            >
              <IoCloseSharp className="w-6 h-6" />
            </button>

            <div>
              <h2 className="font-bold text-slate-800 text-lg leading-snug">
                {t("Cancel Appointment")}
              </h2>
              <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mt-0.5">
                {t("Select cancellation reason")}
              </p>
            </div>

            <div className="flex flex-col gap-3 mt-1.5">
              {cancelReasonList.map((item, index) => (
                <label
                  onClick={() => setSelectReason(item.id)}
                  key={index}
                  className={`flex items-center gap-3 p-3.5 border rounded-2xl cursor-pointer transition-all duration-155 ${
                    selectReason === item.id
                      ? "border-indigo-600 bg-indigo-50/30 text-indigo-900 font-bold"
                      : "border-slate-200 hover:border-slate-300 text-slate-700 font-medium"
                  }`}
                >
                  <div className="w-[20px] check-box flex items-center justify-center shrink-0">
                    <div
                      className={`w-5 h-5 rounded-full flex items-center justify-center border transition-colors ${
                        selectReason === item.id
                          ? "border-indigo-600 bg-indigo-600"
                          : "border-slate-300"
                      }`}
                    >
                      <span
                        className={`w-2 h-2 rounded-full bg-white duration-150 ${selectReason === item.id ? "scale-100" : "scale-0"}`}
                      ></span>
                    </div>
                  </div>
                  <span className="text-sm leading-tight">{item.title}</span>
                </label>
              ))}

              {selectReason === 4 && (
                <input
                  type="text"
                  onChange={(e) => setOtherReason(e.target.value)}
                  className="border border-slate-205 focus-within:outline-none focus:border-indigo-650 focus:ring-1 focus:ring-indigo-650 w-full py-3 px-4 rounded-2xl text-sm mt-1"
                  placeholder={t("Enter other reason details")}
                />
              )}
            </div>

            <div className="grid grid-cols-2 gap-4 mt-2">
              <button
                onClick={() => setIsCancelBox(false)}
                className="py-3 bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold rounded-2xl text-sm transition-all duration-150 active:scale-98"
              >
                {t("Close")}
              </button>
              <button
                onClick={HandleCancelAppointment}
                className="py-3 bg-rose-600 hover:bg-rose-700 text-white font-bold rounded-2xl text-sm transition-all duration-150 active:scale-98 shadow-md shadow-rose-600/10"
              >
                {t("Confirm Cancellation")}
              </button>
            </div>
          </div>
        </div>
      )}

      {showChat && (
        <div
          onClick={() => setShowChat(false)}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-[24px] shadow-2xl max-w-xl w-full max-h-[85vh] flex flex-col p-6 relative overflow-hidden"
          >
            <button
              onClick={() => setShowChat(false)}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-650 hover:bg-slate-100 transition-all duration-200 z-20"
              aria-label="Close chat"
            >
              <IoCloseSharp className="w-6 h-6" />
            </button>
            <div className="flex-1 mt-2 overflow-hidden flex flex-col">
              <Chat index={1} setShowChat={setShowChat} doctorId={selectDoc} />
            </div>
          </div>
        </div>
      )}

      {deviceCheck && (
        <div
          onClick={() => setDeviceCheck(false)}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-3xl p-6 shadow-2xl max-w-sm w-full text-center"
          >
            <div className="w-12 h-12 rounded-full bg-amber-50 text-amber-600 flex items-center justify-center mx-auto mb-4 border border-amber-100">
              <LuPhoneCall className="w-6 h-6" />
            </div>
            <h2 className="font-bold text-slate-800 text-lg mb-2">
              {t("Audio Input Required")}
            </h2>
            <p className="text-slate-505 text-sm leading-relaxed">
              {t(
                "Required for voice and video calls. Make sure your audio device (headset, speakers, or microphone) is connected and working.",
              )}
            </p>
            <button
              onClick={() => setDeviceCheck(false)}
              className="mt-5 w-full py-2.5 bg-slate-900 hover:bg-slate-800 text-white font-semibold rounded-xl text-sm transition-all duration-155 active:scale-98"
            >
              {t("Got It")}
            </button>
          </div>
        </div>
      )}

      {isReview && (
        <div
          onClick={() => setIsReview(false)}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-3xl p-6 shadow-2xl max-w-md w-full max-h-[85vh] overflow-y-auto relative flex flex-col gap-5"
          >
            <button
              onClick={() => setIsReview(false)}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-650 hover:bg-slate-100 transition-all duration-200"
            >
              <IoCloseSharp className="w-6 h-6" />
            </button>

            <div className="text-center">
              <h2 className="font-bold text-slate-800 text-lg leading-snug">
                {t("Leave a Review")}
              </h2>
              <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mt-0.5">
                {t("How was your consultation experience?")}
              </p>
            </div>

            <div className="flex flex-col items-center gap-3 py-4 border-y border-slate-100">
              <h4 className="font-bold text-slate-700 text-sm">
                {t("Tap to Rate")}
              </h4>
              <div className="flex items-center gap-2">
                {[1, 2, 3, 4, 5].map((index) => (
                  <button
                    onClick={() => setReviewIndex(index)}
                    key={index}
                    className="focus:outline-none transition-transform active:scale-90"
                  >
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      fill={reviewIndex >= index ? "#eab308" : "none"}
                      className={
                        reviewIndex >= index
                          ? "text-amber-500"
                          : "text-slate-300"
                      }
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                ))}
              </div>
            </div>

            <div className="flex flex-col gap-1.5">
              <label className="font-bold text-slate-700 text-sm">
                {t("Write Your Review")}
              </label>
              <textarea
                onChange={(e) => setReviewText(e.target.value)}
                className="w-full min-h-[100px] max-h-[100px] border border-slate-205 rounded-2xl px-4 py-3 focus-within:outline-none focus:border-indigo-650 focus:ring-1 focus:ring-indigo-650 text-sm shadow-sm"
                placeholder={t("Share details of your experience here...")}
              />
            </div>

            <div className="grid grid-cols-2 gap-4 mt-2">
              <button
                onClick={() => setIsReview(false)}
                className="py-3 bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold rounded-2xl text-sm transition-all duration-150 active:scale-98"
              >
                {t("Maybe Later")}
              </button>
              <button
                onClick={HandleAddReview}
                className="py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-bold rounded-2xl text-sm transition-all duration-150 active:scale-98 shadow-md shadow-indigo-600/10"
              >
                {t("Submit Review")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingDetails;
